var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon93NpsScore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_157154",
    "data-name": "Group 157154",
    transform: "translate(-416.838 -923.838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_453",
    "data-name": "Ellipse 453",
    transform: "translate(416.838 923.838)",
    fill: "#fffefa",
    stroke: "#de5a41",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 38,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 37.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_157085",
    "data-name": "Group 157085",
    transform: "translate(430.406 938.982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2865",
    "data-name": "Path 2865",
    d: "M39.09,4.886V0H9.773V4.886H0v7.329A12.216,12.216,0,0,0,10.554,24.26a14.659,14.659,0,0,0,11.434,9.773v9.944H14.659v4.886H34.2V43.977H26.875V33.984a14.659,14.659,0,0,0,11.434-9.773,12.216,12.216,0,0,0,10.554-12V4.886Zm-34.2,7.329V9.773H9.773V19.13A7.329,7.329,0,0,1,4.886,12.216Zm39.09,0A7.329,7.329,0,0,1,39.09,19.13V9.773h4.886Z",
    fill: "#de5a41"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_93",
    "data-name": 93,
    transform: "translate(15.49 19.856)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Poppins-Bold, Poppins",
    fontWeight: 700,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "93"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon93NpsScore);
export default __webpack_public_path__ + "static/media/icon-93-nps-score.2629fccfc2f9cacdd8de6947e183d099.svg";
export { ForwardRef as ReactComponent };